module.exports = __webpack_public_path__ + "img/reports_sidebar_inactive.631de5ff.svg";